import { render, staticRenderFns } from "./cooperateOrganizationList.vue?vue&type=template&id=3680a479&scoped=true"
import script from "./cooperateOrganizationList.vue?vue&type=script&lang=js"
export * from "./cooperateOrganizationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3680a479",
  null
  
)

export default component.exports